import { useState } from "react";
import { API } from "@/lib/api";

const FALLBACK = "/logo-tssmx.png";

export const BrandLogo = ({ className, alt = "TSSMX", testid }) => {
  const [src, setSrc] = useState(`${API}/files/public-logo`);
  return <img src={src} alt={alt} className={className} data-testid={testid} onError={() => setSrc(FALLBACK)} />;
};
